/* eslint-disable no-param-reassign */
import _ from 'underscore';
import { panelDecorator } from '@bingads-webui-campaign-react/panel-decorator';
import { RECOMMENDATION_TYPES } from '@bingads-webui-campaign/recommendation-core';
import { NewAdsInlineView } from '@bingads-webui-campaign/recommendation-inline-new-ads-view';
import { PANEL_DECORATOR_TITLE, PANEL_WIDTH } from '../const';

export const openNewAdsViewEditor = (
  deps,
  i18n,
  newI18n,
  type,
  gridService,
  recommendation,
  router,
  isMCC,
  gridView,
  readOnly,
  editor,
  apply
) => {
  const panelOptions = {
    width: PANEL_WIDTH[type],
    i18n,
    panelReadyAriaLabel: i18n.getString('Association editor side panel opened'),
    panelClassName: type === RECOMMENDATION_TYPES.IMPROVE_RESPONSIVE_SEARCH_ADS ?
      'ad-editor-panel recommend-ad-editor-panel recommend-improve-rsa-editor-panel' :
      'ad-editor-panel recommend-ad-editor-panel',
  };
  const EditorCtor = panelDecorator(NewAdsInlineView, panelOptions);
  editor = new EditorCtor(_.extend(
    {
      title: newI18n.getString(PANEL_DECORATOR_TITLE[type]),
    },
    {
      eventsToActions: [{
        event: 'created',
        action: () => { editor.remove(); },
      }, {
        event: 'cancel',
        action: () => { editor.remove(); },
      }],
      onClose: () => { editor.remove(); },
    },
    {
      deps,
      data: recommendation,
      i18n,
      newI18n,
      router,
      type,
      gridView,
      readOnly,
      isMCC,
      gridService,
      applyAction: (opportunities, userInputs, context) => {
        apply(opportunities, userInputs, context, editor);
      },
    }
  )).render();
};
